import moment from "moment/moment";

const formatPrice = price => new Intl.NumberFormat('cs-CZ', {style: 'currency', currency: 'CZK'}).format(
    price,
)

const translateArrayKey = (array, t, key = 'label') => {
    return array.map(item => {
        item[key] = t(item[key]);
        return item;
    });
}

const getTranslatedDefaultOption = (array, value, t) => {
    const item = array.find(item => item.value === value);
    if (item) {
        item['label'] = t(item['label']);
        return item;
    }
    return '';
}


const toDateOrNull = (d) => {
    if (!d) return null;
    const m = moment(d);
    return m.isValid() ? m.toDate() : null;
}
const toDateOrNow = (d) => {
    const m = moment(d);
    return m.isValid() ? m.toDate() : new Date();
}

export {
    formatPrice,
    translateArrayKey,
    getTranslatedDefaultOption,
    toDateOrNow,
    toDateOrNull
}